import styled, { css } from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;
`;

export const BodyPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding-inline: 16px;
`;

export const CardBodyContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */
  grid-gap: 16px;
  width: 100%;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${Colors.Border_Color_1};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.h3`
  color: ${Colors.text_Color_1};
  font-size: 1em;
  font-weight: 700;
`;

export const CardSubTitle = styled.p`
  color: ${Colors.text_Color_1};
  font-size: 0.7em;
  font-weight: 300;
`;

export const AddButton = styled.button`
  background: #ffffff10;
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.text_Color_1};
  font-size: 0.65em;
  font-weight: 400;

  cursor: pointer;

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: background;

  &:hover {
    background: #ffffff20;
  }
  &:active {
    background: #ffffff30;
  }
  &:focus {
    box-shadow: 0 0 0 2px ${Colors.primary_Color_1};
  }
  &:disabled {
    background: #ffffff05;
    color: #ffffff50;
    cursor: not-allowed;
  }
`;

// export const CardSubTitle = styled.p`
//   color: ${Colors.text_Color_1};
//   font-size: 0.7em;
//   font-weight: 300;
// `;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  input {
    cursor: pointer !important;
    background: transparent !important;
    border: 1px solid rgb(255 255 255 / 0.15) !important;
    border-radius: 8px !important;
    padding: 16px !important;
    color: #fff !important;
    font-size: 0.7em !important;
    font-weight: 300 !important;
    width: 100% !important;
    height: 36px !important;
    box-shadow: none !important;
  }

  label {
    display: block;
    margin-bottom: 0.8rem;
    color: ${Colors.text_Color_1};
    font-size: 0.65em;
    font-weight: 500;
    line-height: 10px;
  }

  ${props =>
    props.disabled &&
    css`
      label {
        opacity: 0.3;
        cursor: not-allowed;
      }
      input {
        cursor: not-allowed !important;
        pointer-events: none !important;
        opacity: 0.5 !important;
      }
    `}
`;

export const IconeSolicitante = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ffffff25;
  height: 100%;
  width: 100%;
  border-radius: 8px;

  p {
    font-size: 0.8em;
    color: ${Colors.text_Color_1};
    font-weight: 300;
    text-align: center;
  }
`;

export const ResponsaveisMudancaContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 16px;
  width: 100%;
`;

export const ClassificacoesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */
  width: 100%;
`;

export const RadiosContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 24px;
`;

export const RadioContent = styled.div`
  display: grid;
  grid-template-columns: ${({ twoColumns }) => (twoColumns ? '1fr 1fr' : '1fr')};
  grid-gap: 12px;
`;

// card planos styles
export const CardPlanoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px;
  border: 1px solid #ffffff25;
  border-radius: 8px;
`;

export const CardPlanoContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const CardPlanoTitleContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  p {
    font-size: 0.7em;
    color: ${Colors.text_Color_1};
    font-weight: 500;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;
  border: none;
  border-radius: 4px;

  font-size: 0.8em;
  font-weight: 300;
  cursor: pointer;

  height: 24px;
  width: 24px;

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: background, border;

  &:hover {
    background: #ffffff10;
    border: 1px solid #ffffff25;
  }
  &:active {
    background: #ffffff10;
    border: 1px solid #ffffff25;
  }
  /* &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${Colors.primary_Color_1};
  } */
`;

// export const AddButton = styled.button`
//   background: #ffffff10;
//   border: 1px solid #ffffff25;
//   border-radius: 8px;
//   padding: 4px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   /* color: ${Colors.text_Color_1};
//   font-size: 0.65em;
//   font-weight: 400; */

//   position: absolute;
//   top: 14px;
//   right: 16px;

//   cursor: pointer;

//   transition-timing-function: ease-in-out;
//   transition-duration: 300ms;
//   transition-property: background;

//   &:hover {
//     background: #ffffff20;
//   }
//   &:active {
//     background: #ffffff30;
//   }
//   &:focus {
//     outline: none;
//     box-shadow: 0 0 0 2px ${Colors.primary_Color_1};
//   }
//   &:disabled {
//     background: #ffffff05;
//     color: #ffffff50;
//     cursor: not-allowed;
//   }
// `;

// export const AddButtonOld = styled.button`
//   background: #ffffff10;
//   border: 1px solid #ffffff25;
//   border-radius: 8px;
//   padding: 8px 16px;
//   color: ${Colors.text_Color_1};
//   font-size: 0.8em;
//   font-weight: 400;

//   cursor: pointer;

//   transition-timing-function: ease-in-out;
//   transition-duration: 300ms;
//   transition-property: background;

//   &:hover {
//     background: #ffffff20;
//   }
//   &:active {
//     background: #ffffff30;
//   }
//   &:focus {
//     outline: none;
//     box-shadow: 0 0 0 2px ${Colors.primary_Color_1};
//   }
//   &:disabled {
//     background: #ffffff05;
//     color: #ffffff50;
//     cursor: not-allowed;
//   }
// `;
